import { required, optional, obj, array } from "AppReact/schema";
import { sub } from "date-fns";

export const subtitle = {
  id: optional("integer"),
  url: required("string"),
  uuid: required("string"),
  is_default: required("boolean"),
  filename: required("string"),
}

export const singleVideoState = {
  id: optional("integer"),
  video_filename: required("string"),
  title: required("string"),
  titleError: required("string"),
  alt_text: required("string"),
  altError: required("string"),
  description: required("string"),
  descriptionError: required("string"),
  transcript: required("string"),
  transcriptError: required("string"),
  personId: required("string"),
  personIdError: required("string"),
  categoryId: required("string"),
  categoryIdError: required("string"),
  selectedTags: array("integer"),
  selectedTagsError: required("string"),
  is_highlighted: required("boolean"),
  num_views: required("string"),
  subtitles: array(obj(subtitle)),
  video: obj({
    file: obj({
      filename: required("string"),
      type: required("string"),
    }),
    url: required("string"),
    uuid: required("string"),
    filename: required("string"),
    duration: required("string"),
    reupload: required("boolean"),
    isUploading: required("boolean"),
  }),
  videoThumbnail: obj({
    url: required("string"),
    uuid: required("string"),
    filename: required("string"),
  }),
};


export const trainingVideoModal = {
  isVisible: required("boolean"),
  ...singleVideoState,
};

export const singleVideoDefaultValue = {
  id: null,
  video_filename: "",
  title: "",
  titleError: "",
  alt_text: "",
  altError: "",
  description: "",
  descriptionError: "",
  transcript: "",
  transcriptError: "",
  personId: "",
  personIdError: "",
  categoryId: "",
  categoryIdError: "",
  is_highlighted: false,
  selectedTags: [],
  selectedTagsError: "",
  num_views: "",
  subtitles: [],
  video: {
    file: {
      filename: "",
      type: "",
    },
    uuid: "",
    filename: "",
    duration: "",
    reupload: false,
    isUploading: false,
  },
  videoThumbnail: {
    uuid: "",
    url: "",
    filename: "",
  },
};

export const trainingVideoModalDefaultValue = {
  isVisible: false,
  ...singleVideoDefaultValue,
};


export const trackedKeys = [
  { value: "title", type: "string" },
  { value: "description", type: "string" },
  { value: "alt_text", type: "string" },
  { value: "personId", type: "integer" },
  { value: "categoryId", type: "integer" },
  { value: "is_highlighted", type: "boolean" },
  { value: "selectedTags", type: "array-integer" },
  { value: "transcript", type: "string" },
  { value: "videoThumbnail", type: "object", subType: "media" },
  { value: "video", type: "object", subType: "media" },
  { value: "subtitles", type: "array-object", subType: "media" },
];

export const singleVideoServerState = trackedKeys.reduce((acc, key) => {

  let [typePartOne, typePartTwo] = [key.type, 'primitive']

  if (typePartTwo === 'primitive') {
    acc[key.value] = required(typePartOne)
  }

  if (key.type === 'array-integer') {
    acc[key.value] = array("integer");
  }


  if (key.subType === 'media') {
    if (key.type === 'object') {
      acc[key.value] = obj({
        uuid: required("string"),
        url: required("string"),
        filename: required("string"),
      })
    }

    if (key.type === 'array-object') {
      acc[key.value] = array(obj({
        uuid: required("string"),
        url: required("string"),
        filename: required("string"),
      }))

    }
  }

  return acc;
}, {});
